import http from "../../http";

/** 楼宇公示 — /resident/api/resident/houseBuildingNotice */
const BASE = "/resident/api/resident/houseBuildingNotice";

export default {
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  selectById(r) {
    return http.get(`${BASE}/detail`, r);
  },
  save(r) {
    return http.payload(`${BASE}/save`, r);
  },
  publish(r) {
    return http.tip.post(`${BASE}/publish`, r);
  },
  updateStatus(r) {
    return http.tip.post(`${BASE}/updateStatus`, r);
  },
};
